import { useI18n } from '@/lib/i18n';
import { OrderInteraction, OrderPlatform } from '@/types';

export default function Faq({ platform = null, interaction = null }: { platform?: OrderPlatform | null; interaction?: OrderInteraction | null }) {
  const { tArr } = useI18n();

  return (
    <>
      {tArr<{ question: string; answer: string }>('faq')
        .filter((i) => {
          const includePlatform = platform === null ? !i.question.includes(':Platform') && !i.answer.includes(':Platform') : true;
          const includeInteraction = interaction === null ? !i.question.includes(':Interaction') && !i.answer.includes(':Interaction') : true;

          return includePlatform && includeInteraction;
        })
        .map((item, n) => (
          <div key={n}>
            <h4>{item.question.replace(':Platform', platform!).replace(':Interaction', interaction!)}</h4>
            <p>{item.answer.replace(':Platform', platform!).replace(':Interaction', interaction!)}</p>
          </div>
        ))}
    </>
  );
}
